<p-dialog [(visible)]="baseDialog" [style]="{width: '450px'}" header="Nova Base - Modal" [modal]="true" styleClass="p-fluid" (onHide)="escondeDialogBase()">
    <ng-template pTemplate="content">
        <div class="field">
            <label>Criando no servidor: <b>{{ servidor.nome }}</b></label>
        </div>
        <div class="field">
            <label for="cliente">Cliente:</label>
            <p-dropdown [options]="clientes" optionLabel="razaoSocial" [(ngModel)]="clienteSelecionado" inputId="id" placeholder="Selecione um cliente"></p-dropdown>
            <small class="p-error" *ngIf="enviadoBase && !clienteSelecionado.id">Cliente é obrigatório.</small>
        </div>
        <div class="field">
            <label for="nome">Nome da Base:</label>
            <input type="text" pInputText id="nome" [(ngModel)]="base.nome" required autofocus />
            <small class="p-error" *ngIf="enviadoBase && !base.nome">Nome é obrigatório.</small>
        </div>
        <div class="formgrid grid">
            <div class="field col">
                <label for="usuario">Usuário:</label>
                <input type="text" pInputText id="usuario" [(ngModel)]="base.usuario" required autofocus />
                <small class="p-error" *ngIf="enviadoBase && !base.usuario">Usuário é obrigatório.</small>
            </div>
            <div class="field col">
                <label for="senha">Senha:</label>
                <input type="password" pInputText id="senha" [(ngModel)]="base.senha" required autofocus />
                <small class="p-error" *ngIf="enviadoBase && !base.senha">Senha é obrigatória.</small>
            </div>
        </div>
        
    </ng-template>
    <ng-template pTemplate="footer">
        <button pButton label="Cancelar" icon="pi pi-times" class="p-button-text" (click)="escondeDialogBase()"></button>
        <button pButton label="Salvar" icon="pi pi-check" class="p-button-text" (click)="salvarBaseNova()"></button>
    </ng-template>
</p-dialog>